import { Component, OnInit, ViewChild, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { WebapiService } from '../shared/services/webapi.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SlimScrollOptions, SlimScrollEvent } from 'ngx-slimscroll';
declare var bootstrap;
declare var $: any;

@Component({
  selector: 'app-seriesview',
  templateUrl: './seriesview.component.html',
  styleUrls: ['./seriesview.component.scss']
})
export class SeriesviewComponent implements OnInit, OnChanges {
  @ViewChild('videoFileContainer', { static: false }) videoFileContainer;
  seriesid = "";
  skillSubmitting = false;
  legalitySubmitting = false;
  videoDetails: any;
  page = 1;
  user: any;
  series = [];
  totalvideo = 0;
  index = 0;
  sereisdetail = null;
  noVideos = true;
  opts: SlimScrollOptions;
  scrollEvents: EventEmitter<SlimScrollEvent>;
  notes = "";
  formSubmitting = false;
  myVideo = null;
  sending = false;
  plan = null;
  private progressUpdateInterval = 5000; // Update progress every 5 seconds
  private lastProgressUpdateTime = 0;

  constructor(
    private toastrService: ToastrService, 
    public webApi: WebapiService, 
    private route: ActivatedRoute, 
    public router: Router
  ) {}

  getStyles(seriesdata) {
    if (seriesdata && seriesdata.background && seriesdata.background != "") {
      return "background: url('" + this.getThumbUrl(seriesdata.background) + "') !important";
    } else {
      return "";
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.videoFileContainer) {
      this.videoFileContainer.nativeElement.load();
    }
  }

  ngOnInit(): void {
    this.seriesid = this.route.snapshot.paramMap.get("slug");
    if (this.seriesid) {
      this.seriesid = this.seriesid.split('-').pop();
    }
    this.getSeriesVideos();

    this.scrollEvents = new EventEmitter<SlimScrollEvent>();
    this.opts = new SlimScrollOptions({
      position: "right",
      barBackground: "rgb(108, 105, 105)",
      barOpacity: "0.3",
      barWidth: "6",
      barBorderRadius: "10",
      barMargin: "0",
      gridBackground: "#d9d9d9",
      gridOpacity: "1",
      gridWidth: "0",
      gridBorderRadius: "20",
      gridMargin: "0",
      alwaysVisible: true,
      alwaysPreventDefaultScroll: undefined,
    });
  }

  private setupVideoListeners() {
    if (!this.videoFileContainer?.nativeElement) return;

    const videoElement = this.videoFileContainer.nativeElement;
    
    // Remove existing listeners to prevent duplicates
    videoElement.removeEventListener("timeupdate", this.handleTimeUpdate);
    videoElement.removeEventListener("ended", this.handleVideoEnd);
    videoElement.removeEventListener("loadedmetadata", this.handleMetadata);

    // Add new listeners
    videoElement.addEventListener("timeupdate", this.handleTimeUpdate.bind(this));
    videoElement.addEventListener("ended", this.handleVideoEnd.bind(this));
    videoElement.addEventListener("loadedmetadata", this.handleMetadata.bind(this));
  }

  private handleTimeUpdate(event: Event) {
    const videoElement = event.target as HTMLVideoElement;
    const currentTime = videoElement.currentTime;
    const currentTimeMs = Date.now();

    // Throttle progress updates to avoid too many API calls
    if (currentTimeMs - this.lastProgressUpdateTime >= this.progressUpdateInterval) {
      this.saveVideoProgress(currentTime);
      this.lastProgressUpdateTime = currentTimeMs;
    }
  }

  private handleMetadata(event: Event) {
    const videoElement = event.target as HTMLVideoElement;
    if (this.videoDetails?.progress > 0) {
      // Only resume if progress is valid (not at the end of the video)
      if (this.videoDetails.progress < videoElement.duration * 0.95) {
        videoElement.currentTime = this.videoDetails.progress;
      }
    }
  }

  private handleVideoEnd() {
    console.log('Video ended, playing next video...');
    this.playNextVideo();
  }

  private saveVideoProgress(currentTime: number) {
    if (!this.videoDetails || this.sending) return;

    this.sending = true;
    const params = {
      video_id: this.videoDetails.id,
      signature_series_id: this.seriesid, 
      currenttime: currentTime
    };

    this.webApi.addProgress(params).subscribe(
      () => {
        // Update local progress to avoid unnecessary future updates
        this.videoDetails.progress = currentTime;
        this.sending = false;
      },
      error => {
        console.error('Error saving progress:', error);
        this.sending = false;
      }
    );
  }

  getSeriesVideos() {
    this.noVideos = false;
    this.webApi.setLoader(true);
    
    const params = {
      "keyword": '',
      "series_id": this.seriesid,
      "page": this.page
    };

    this.webApi.getSeriesVideos(params).subscribe(
      (video: any) => {
        this.series = [...video.data];
        this.plan = video.plan;

        if (!this.plan || this.plan.subscription_cancelled == 1 || this.plan.subscription_cancelled == 2) {
          this.router.navigate(['/']);
          return;
        }

        this.sereisdetail = video.series;
        if (this.series.length == 0) {
          this.noVideos = true;
          this.webApi.setLoader(false);
          return;
        }

        // Initialize with first video
        this.videoDetails = this.series[0];
        this.index = 0;
        this.notes = this.videoDetails.notes;

        // Setup video player after view updates
        setTimeout(() => {
          this.setupVideoListeners();
          this.playCurrentVideo();
        }, 100);

        this.totalvideo = video.total;
        this.webApi.setLoader(false);
      },
      error => {
        this.toastrService.error("Unable to load series videos");
        this.webApi.setLoader(false);
      }
    );
  }

  private playCurrentVideo() {
    if (!this.videoFileContainer?.nativeElement) return;

    const videoElement = this.videoFileContainer.nativeElement;
    
    // Only autoplay if video is allowed
    if (this.videoDetails.allowed !== 0) {
      videoElement.play().catch(error => {
        console.log('Autoplay prevented:', error);
        // Show play button to let user initiate playback
      });
    }
  }

  addToFav(event, videoDetails: any) {
    event.preventDefault();
    event.stopPropagation();
    this.webApi.setLoader(true);
    
    this.webApi.addVideoToFavourite(videoDetails.id).subscribe(
      (data: any) => {
        if (data.success) {
          videoDetails.fav = data.fav;
          this.toastrService.success(data.message);
        }
        this.webApi.setLoader(false);
      },
      error => {
        this.webApi.setLoader(false);
        this.toastrService.error("Unable to update favorites");
      }
    );
  }

  addNote() {
    if (this.formSubmitting) return;
    
    this.formSubmitting = true;
    const params = {
      video_id: this.videoDetails.id,
      signature_series_id: this.videoDetails.signature_series_id,
      notes: this.notes
    };

    this.webApi.addnotes(params).subscribe(
      (data: any) => {
        if (data.success == 1) {
          this.videoDetails.notes = this.notes;
          this.toastrService.success(data.message);
        } else {
          this.toastrService.error(data.message);
        }
        this.formSubmitting = false;
      },
      error => {
        this.formSubmitting = false;
        this.toastrService.error("Unable to save notes");
      }
    );
  }

  openDetails(video: any, autoPlay: boolean = true) {
    // Don't proceed with locked videos
    if (video.allowed == 0) {
      setTimeout(() => {
        const modalElement = document.getElementById('videos-locked-popup-modal');
        if (modalElement) {
          new bootstrap.Modal(modalElement, { keyboard: true }).show();
        }
      }, 300);
      return;
    }

    // Update current index
    this.index = this.series.findIndex(item => item.id === video.id);
    if (this.index === -1) return;

    // Pause any currently playing videos
    $('video').trigger('pause');

    // Update video details and notes
    this.videoDetails = video;
    this.notes = this.videoDetails.notes;

    // Setup video element with new source
    if (this.videoFileContainer?.nativeElement) {
      const videoElement = this.videoFileContainer.nativeElement;
      videoElement.load();
      
      // Setup listeners after a brief delay to ensure the new video is ready
      setTimeout(() => {
        this.setupVideoListeners();
        if (autoPlay) {
          this.playCurrentVideo();
        }
      }, 100);
    }
  }

  playNextVideo() {
    if (!this.series || this.index >= this.series.length - 1) {
      console.log('Reached the end of the playlist');
      return;
    }

    const nextVideo = this.series[this.index + 1];
    this.openDetails(nextVideo, true);
  }

  // Helper methods for URLs
  getThumbUrl(url: string) {
    return "assets/images/" + url;
  }

  getVideoUrl(url: string) {
    return "assets/videos/" + url;
  }

  getInstructorThumbUrl(url: string) {
    return "assets/instructors/" + url;
  }
}